module.exports = __webpack_public_path__ + "img/Generic File Icon.902213e4.png";